import api from '@/services/utils/base';

export default class Import {
  postSettings(from: string, payload: any) {
    return api.post(`import/${from}`, payload).then((res: any)=> res.data.payload);
  }
}
